import axios from 'axios';
import toastr from 'toastr';
import store from 'store';

const state = {
  trucks: {},
};

const getters = {
  getTrucksFiltered: st => query => {
    axios.get(`trucks?${query}`).then(res => {
      st.trucks = res.data;
    });
  },
};

const mutations = {
  setTrucks: (st, payload) => {
    st.trucks = payload;
  },
};

const actions = {
  getTrucks: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('setTrucks', {});
      if (store.get('permissions').indexOf('carriers.trucks.index') >= 0) {
        axios
          .get(`trucks`)
          .then(res => {
            commit('setTrucks', res.data);
            resolve();
          })
          .then(() => {
            reject();
          });
      }
    });
  },
  saveTruck: ({ truckId, truck }) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`trucks/${truckId}`, truck)
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeTruck: ({ dispatch }, { truckId }) => {
    axios.delete(`trucks/${truckId}`).then(() => {
      toastr.success('Successfully removed truck');
      dispatch('getTrucks');
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/trucks.js